import React from 'react';
import { defaultSettings } from './default/settings';
const createPlugin = (settings) => {
    var _a, _b;
    const mergedSettings = Object.assign(Object.assign({}, defaultSettings), settings);
    const Controls = mergedSettings.Controls;
    const Renderer = mergedSettings.Renderer;
    const plugin = {
        controls: {
            type: 'custom',
            Component: (props) => React.createElement(Controls, Object.assign({}, props, mergedSettings)),
        },
        Renderer: (props) => React.createElement(Renderer, Object.assign({}, props, mergedSettings)),
        id: 'migeran/editor/core/content/input',
        version: 1,
        icon: mergedSettings.icon,
        title: (_a = mergedSettings.translations) === null || _a === void 0 ? void 0 : _a.pluginName,
        isInlineable: true,
        description: (_b = mergedSettings.translations) === null || _b === void 0 ? void 0 : _b.pluginDescription,
    };
    return plugin;
};
export default createPlugin;
//# sourceMappingURL=createPlugin.js.map